import { useQuery } from '@tanstack/react-query';

import { type GivingSettings } from '@/lib/giving-default-funds';
import { api } from '@/lib/api';

export function useGivingSettings() {
  return useQuery({
    queryKey: ['giving', 'settings'],
    queryFn: () => api.get<GivingSettings>('/giving/settings'),
  });
}
